/**
 * Video configuration for Coupling WNC website.
 *
 * Videos can be self-hosted MP4s (src) or YouTube embeds (youtubeId).
 * Self-hosted files live in public/videos/.
 */

export const videos = {
  couplingIntro: {
    src: '/videos/how-coupling-works.mp4',
    title: 'Coupling WNC — How It Works',
  },
  howToMintTokens: {
    youtubeId: 'PLACEHOLDER_HOW_TO_MINT',
    title: 'How to Mint Tokens on Coupling',
  },
} as const;
